import React from 'react';
import './MyServices.css';
import Lottie from 'react-lottie-player';
import lottieJson from '../../lottie/web.json';
import lottieJson2 from '../../lottie/web2.json';

const MyServices = () => {
    return (
        <div className="container txbg">
            <div className="row txbg">
                <h2 className="myProjectstext mb-5">My <br /> Services</h2>

                <div className="d-flex flex-wrap justify-content-between txbg">
                <div className="bgglass2 txbg text-center p-2 col-md-5">
                    <Lottie
                        className="mx-auto w-100"
                        loop
                        animationData={lottieJson}
                        play
                        style={{ width: 200, height: 200, background: "rgba(0, 0, 0, 0)" }}
                    />
                    <h5 className="txbg">Web Designing</h5>
                    <p className="txbg">Designing an interactive and elegant website. Front End Technologies are HTML, CSS, Bootstrap, JavaScript, React JS, Tailwind CSS, Material UI </p>
                </div>
                <div className="bgglass2 text-center p-2 col-md-5">
                    <Lottie
                        className="mx-auto w-100"
                        loop
                        animationData={lottieJson2}
                        play
                        style={{ width: 250, height: 250, background: "rgba(0, 0, 0, 0)" }}
                    />
                    <h5 className="txbg">MERN Stack Web Development</h5>
                    <p className="txbg">Developing Websites using MongoDB, React JS, Express JS, Node JS</p>
                </div>
                </div>
            </div>
            <hr className=" text-white w-75 mt-5 mb-0 me-auto" />
        </div>
    );
};

export default MyServices;